// @flow

import type {Action} from '../../types'
import type {GbiprojectState} from '../types'
import type {SetErrorPayload} from '../actions/setError'

export function setErrorReducer(state: GbiprojectState, action: Action<SetErrorPayload>): GbiprojectState {

  return {
    ...state,
    error: action.payload.error,
  }
}
